import { Typography } from "@mui/material";
import { FC } from "react";
import Container from "../../components/UI/Container";

const NewsPage: FC = () => {
  return (
    <Container>
      <Typography color="primary" textAlign="center" variant="h3">
        News Page
      </Typography>
    </Container>
  );
};

export default NewsPage;
